import { createHashHistory, createRootRoute, createRoute, createRouter, Outlet } from "@tanstack/react-router";
import { z } from "zod";
import { AppShell } from "@/components/layout/AppShell";
import { AdminPeoplePage } from "@/pages/admin/AdminPeoplePage";
import { Landing } from "@/pages/Landing";
import { SettingsPage } from "@/pages/settings/SettingsPage";
import { TripPlannerPage } from "@/pages/trip-planner/TripPlannerPage";

const settingsSearchSchema = z.object({
  tab: z.enum(["crew", "rates", "airports", "tier-equivalencies"]).optional(),
});

const rootRoute = createRootRoute({ component: Outlet });

const appRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "app",
  component: AppShell,
});

const landingRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: Landing,
});

const settingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "settings",
  component: SettingsPage,
  validateSearch: settingsSearchSchema.parse,
});

const tripPlannerRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "trip-planner",
  component: TripPlannerPage,
});

const peopleRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "admin/people",
  component: AdminPeoplePage,
});

const routeTree = rootRoute.addChildren([
  appRoute.addChildren([landingRoute, tripPlannerRoute, settingsRoute, peopleRoute]),
]);

export const router = createRouter({
  routeTree,
  history: createHashHistory(),
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
